






























































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { option, column } from '../interface/'
import { FORM_ITEM_LAYOUT } from '../config/'
import { getResourceDeadline } from '../../../service/manage'
import { BUSSINESS, BUSSINESS_SUBJECTS } from '../../../service/constant'
import { timeColumns } from '../config/columns'

@Component
export default class TaskSummaryCompleted extends Vue {
  private get business() {
    return this.$store.state[BUSSINESS]
  }
  private get subjects() {
    if (!this.timeForm.business_type) return []
    const dict = this.$store.state[BUSSINESS_SUBJECTS]
    return dict[this.timeForm.business_type] || []
  }

  @Watch('timeForm.business_type')
  public onBussinessChange(val) {
    if (val === '') {
      this.timeForm.subject_id = ''
    }
    if (!this.subjects || this.subjects.length == 0) return
    if (!this.subjects.map((item) => item.value).includes(this.timeForm.subject_id)) {
      setTimeout(() => {
        this.timeForm.subject_id = this.subjects[0].value
      })
    }
  }
  async mounted() {
    // this.timeForm.business_type = this.business[0].value
    await this.renderTimelist(1)
  }
  formItemLayout = FORM_ITEM_LAYOUT
  // 资源审核时效
  timeColumns = timeColumns
  timeForm = {
    business_type: '',
    subject_id: '',
    range: ['', '']
  }
  timeDataSource = []
  timePagination = {
    total: 0,
    current: 1,
    showTotal: (total) => `共 ${total} 条`
  }
  onTimeRangeChange(date, dateString) {
    this.timeForm.range = dateString
  }
  handleTimeTableChange(pagination, filters, sorter) {
    this.renderTimelist(pagination.current)
  }
  async handleTimeSubmit(e) {
    this.renderTimelist(1)
  }
  async renderTimelist(page_num) {
    const options = {
      subject_id: Number(this.timeForm.subject_id),
      business_type: Number(this.timeForm.business_type),
      created_start: this.timeForm.range[0],
      created_end: this.timeForm.range[1],
      page_num,
      page_size: 10
    }
    const { list, total } = await getResourceDeadline(options)
    this.timeDataSource = list
    this.timePagination.total = total
    this.timePagination.current = page_num
  }
}
